import { Chip, Typography } from "@mui/material";

import { Box } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import {
  CalendarCheck,
  CopyCheck,
  FolderClosed,
  Goal,
  PartyPopper,
} from "lucide-react";

export default ({
  onPromptSelect,
  disabled,
}: {
  onPromptSelect: (prompt: string) => void;
  disabled: boolean;
}) => {
  const samplePrompts = [
    {
      icon: <CalendarCheck size={20} />,
      title: "Weekly check-in",
      prompt:
        "Populate this document with updated information based on today's date and completed tasks from previous week. If there are no tasks that have been marked as done from the past week, you can include tasks that are in progress, but make sure to emphasize they are in progress.",
    },
    {
      icon: <CopyCheck size={20} />,
      title: "Task ideas",
      prompt: `Create a document with tasks and ideas relevant to this family.

For seasonal -- Include task ideas that seem in line with what this family typically asks for, and/or what most families like theirs might want help in current season. This could be across home, travel, family, shopping, events, etc. Include at least 5 items. Don't suggest things we've talked about in the past 90 days.

For upcoming event support -- Look at their calendar or comms to see what events are after today, and come up with ideas of how the assistant could help. Include at least 5 items. Don't suggest things we've talked about in the past 90 days.

For recurring // annual tasks -- Look at past completed tasks at same time period the year before. Resurface here if relevant. If family has not been active long enough to have tasks from 12 months ago, share up to 5 common recurring tasks. Don't suggest things we've talked about in the past 90 days.

Avoid suggesting tasks that would require in-person help.`,
    },
    {
      icon: <FolderClosed size={20} />,
      title: "Family dossier",
      prompt: `As you look at all the information about this particular family via comms, tasks, facts, notes, and events, can you create a dossier for me about the family?  Please use this template but use your intelligence to come up with additional facts that fit within the broader categories.
For missing details, do not suggest that additional children are missing if they've never mentioned additional children.`,
    },
    {
      icon: <Goal size={20} />,
      title: "Goal progress",
      prompt:
        "Create a supportive message that reviews progress toward goals, acknowledges effort, and provides gentle guidance for next steps.",
    },
    {
      icon: <PartyPopper size={20} />,
      title: "Celebration note",
      prompt:
        "Write an uplifting message celebrating recent accomplishments and milestones, highlighting specific achievements and their impact.",
    },
  ];

  return (
    <Box>
      <Typography variant="bodyHeavy" sx={{ marginBottom: "12px" }}>
        Example prompts
      </Typography>
      <FlexBox gap="8px" sx={{ flexWrap: "wrap" }}>
        {samplePrompts.map((sample, index) => (
          <Chip
            icon={sample.icon}
            variant="outlined"
            label={sample.title}
            key={index}
            sx={{
              svg: {
                marginRight: "0px !important",
              },
            }}
            onClick={() => !disabled && onPromptSelect(sample.prompt)}
          />
        ))}
      </FlexBox>
    </Box>
  );
};
